// extracted by mini-css-extract-plugin
export var externalLink = "_dl-0";
export var internalLinkLabel = "_dl-1";